<script lang="ts">
  // No need for any props in this case
  export let customClass: string = "";
</script>

<div class="card {customClass}">
  <slot></slot>
</div>
